﻿$.fn.dxCtrlGridComDestinataireTrackingClickSms = function custom_dxCtrlGridComDestinataireTrackingClickSms(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridcomdestinatairetrackingclicksms dx-ctrl");
        this.createInstance(new cdxCtrlGridComDestinataireTrackingClickSms(this, option));
    }
    return this;
}

window.cdxCtrlGridComDestinataireTrackingClickSms = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.context_grid == 'undefined') option.context_grid = "gridtrackingclicksms"

    var dxGrid = null
    function mConstruit() {
        container.empty();

        container.css("height", "100%")

        var lstField = mGetLstField()
        var opt = {
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun tracking click SMS",
            typeData: "trackingclicksms",
            lstTypeGrille: ["Lignes"],
            lstLstConditionBase: option.lstLstConditionBase,
            context_grid: option.context_grid,
            getItemTemplateHeight: function (typeGrille) { return 35 },
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
                if (typeof dataTemplate.strcon == 'undefined') {
                    //pas de strcon, on affiche le mail
                    option.bddCtrl.getObjet("com_sms_envoi", dataTemplate.com_sms_envoi.id_com_sms_envoi).mShowPopup()
                } else {
                    //on affiche le strcon
                    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table)
                    option.bddCtrl.getObjet(table.nom, dataTemplate.strcon.id).mShowPopup()
                }
            },
            itemsToolbar: mGetLstButtonToolBar(),
            itemsToolbarSelect: mGetLstButtonToolBarSelect,
            //onShowHideCheck: function (showed) {
            //    if (showed) {
            //        if (dxBtAddDossier) dxBtAddDossier.element().closest(".dx-toolbar-button").show()
            //        if (dxBtAddPipeline) dxBtAddPipeline.element().closest(".dx-toolbar-button").show()
            //        if (dxBtDonwload) dxBtDonwload.element().closest(".dx-toolbar-button").show()
            //    } else {
            //        if (dxBtAddDossier) dxBtAddDossier.element().closest(".dx-toolbar-button").hide()
            //        if (dxBtAddPipeline) dxBtAddPipeline.element().closest(".dx-toolbar-button").hide()
            //        if (dxBtDonwload) dxBtDonwload.element().closest(".dx-toolbar-button").hide()
            //    }
            //},
            onSelectionChanged: function () {
                //if (dxBtAddDossier) {
                //    dxBtAddDossier.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtAddDossier.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                //if (dxBtAddPipeline) {
                //    dxBtAddPipeline.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtAddPipeline.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                //if (dxBtDonwload) {
                //    dxBtDonwload.option("disabled", dxGrid.mGetLstSelectedData().length == 0)
                //    dxBtDonwload.mRempliCompteur(dxGrid.mGetLstSelectedData().length)
                //}
                if (typeof option.onSelectionChanged != 'undefined') option.onSelectionChanged()
            },
            onDisplayButtonLigne: mGetLstButtonLigne,
            itemTemplateGrille: itemTemplateGrille,
            itemTemplateGrillePlus: itemTemplateGrillePlus,
            onEndClickDataGrid: option.onEndClickDataGrid,
            fields: lstField,
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: option.allowCheck,
            allowToolbar: option.allowToolbar,
            allowDeleteInToolbar: false,
            showColumnHeaders: option.showColumnHeaders,
            lstIdTableIdExclu: option.lstIdTableIdExclu,
            lstIdTableIdInclu: option.lstIdTableIdInclu
        }

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid(opt).dxCtrlVirtualGrid("instance")
    }

    function itemTemplateGrille(contentElement, dataTemplate, type) {
        itemTemplateGrilleClickVue(contentElement, dataTemplate, type, dxGrid, { bddCtrl: option.bddCtrl, showCom: option.showVoirDoc, showStrcon: true })
        //var $Table = $("<table style='width:100%;height:100%;'/>").appendTo(contentElement)
        //var $Tr = $("<tr/>").appendTo($Table)
        //var $TdStrCon = $("<td style='width:100%;text-align:left;'/>").appendTo($Tr)
        //var $TdUtiTrack = $("<td style='width:30px;padding:0 3px;'/>").appendTo($Tr)
        //$("<div style='width:24px;height:24px;border-radius:50%;'/>").appendTo($TdUtiTrack).dxCtrlImgStrConUti({
        //    bddCtrl: option.bddCtrl,
        //    idTable: option.bddCtrl.getObjet("utilisateur").mGetTable().id_table,
        //    id: dataTemplate.com_sms_envoi.id_utilisateur,
        //    text: option.bddCtrl.getObjet("utilisateur", dataTemplate.com_sms_envoi.id_utilisateur).mGetLib1()
        //})
        //var tel = new cTelephone(dataTemplate.com_destinataire.tel_code_pays, dataTemplate.com_destinataire.tel_sms)
        //var $TdAdresseEmail = $("<td style='width:1px;padding:0 3px;white-space:nowrap;font-family:barlow condensed;'><u>" + tel.mGetValueMiseEnForme() + "</u></td>").appendTo($Tr).attr("title", tel.mGetValueMiseEnForme())

        //if (typeof dataTemplate.strcon == "undefined") {
        //    $TdStrCon.html("<span style='opacity:0.3;'>Aucune fiche pour le numéro de téléphone</span>")
        //} else {
        //    var table = option.bddCtrl.table.mGetItem(dataTemplate.strcon.id_table_key)
        //    var obj = option.bddCtrl.getObjet(table.nom)
        //    obj.itemTemplateGrille($TdStrCon, dataTemplate.strcon, type)
        //}
    }
    function itemTemplateGrillePlus(contentElement, dataTemplate) {
        $("<span title='" + dataTemplate.track.dcr.toFrenchDateTime() + "'><i class='fas fa-arrow-pointer dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.track.dcr.toDateIlya(true) + "</span>").appendTo(contentElement)


        //var $Span = $("<span style='font-family:barlow condensed;'></span>").appendTo(contentElement)
        //var $ADoc = null

        //if (option.showVoirDoc) {
        //    if (typeof dataTemplate.com_sms_envoi != 'undefined') {
        //        $ADoc = $("<a href='javascript:void(0)'>Voir SMS</a>").appendTo($Span)
        //        $ADoc.on("click", function (e) {
        //            e.stopPropagation()
        //            option.bddCtrl.getObjet("com_sms_envoi", dataTemplate.com_sms_envoi.id_com_sms_envoi).mShowPopup()
        //        })
        //    }
        //    $("<span> &bull; </span>").appendTo($Span)
        //}

        ////if (dataGrid.passe2 == "0") $("<span> &bull; CLICK ROBOT &bull; </span>").appendTo($Span)
        //var $span = $("<span style='font-family:barlow condensed;'>" + ((dataTemplate.com_sms_envoi_lien.libelle == null && dataTemplate.com_sms_envoi_lien.libelle.length > 0 && dataTemplate.com_sms_envoi_lien.libelle != dataTemplate.com_sms_envoi_lien.lien) ? "(" + dataTemplate.com_sms_envoi_lien.libelle + ") " : "") + "</span>").appendTo(contentElement)
        //var $A = $("<a href='javascript:void(0)'>" + dataTemplate.com_sms_envoi_lien.lien.reduit(20) + "</a>").appendTo($span)
        //$A.on("click", function (e) {
        //    e.stopPropagation()
        //    window.open(dataTemplate.com_sms_envoi_lien.lien, "_blank")
        //})
        //$("<span title='" + dataTemplate.com_sms_envoi_tracking_click.dcr.toFrenchDateTime() + "'> &bull; Click " + dataTemplate.com_sms_envoi_tracking_click.dcr.toDateIlya(false) + "</span>").appendTo($span)
    }

    function mGetLstField() {
        var lst = []
        lst = lst.concat([{
            name: "dcr",
            dataField: "dcr",
            caption: "Date click",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            groupIndex: 0,
            sortOrder: "desc",
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Click: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
            filterLinkGrp: "dcr_tri"
        }, {
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        }])
        lst = lst.concat([{
            name: "id_utilisateur",
            dataField: "id_utilisateur",
            caption: "Utilisateur",
            icon: "fas fa-user",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "number",
            calculateGroupValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            groupCellTemplate: function (columnElement, options) {
                var txt = options.data.key
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-user dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + ((txt.length == 0) ? "(Aucun utilisateur)" : txt) + " (" + tot + ")")
            },
            calculateCellValue: function (rowData) {
                return rowData.id_utilisateur
            },
            calculateSortValue: function (rowData) {
                return option.bddCtrl.getObjet("utilisateur", rowData.id_utilisateur).mGetLib1()
            },
            filterProperty: {
                lookup: option.bddCtrl.getObjet("utilisateur").objetMetier.mGetLookUpForFilterBuilder(),
                filterOperations: ["parmi", "notparmi"]
            }
        }, {
            name: "id_com_sms_envoi",
            dataField: "id_com_sms_envoi",
            caption: "id_com_sms_envoi",
            icon: "fas fa-plus",
            allowFilter: false,
            allowGrid: false,
            allowGrouping: false,
            allowSorting: false,
            dataType: "number"
        }, {
            name: "body_txt",
            dataField: "body_txt",
            caption: "texte du sms",
            icon: "fas fa-heading",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Texte SMS: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "lien",
            dataField: "lien",
            caption: "Lien",
            icon: "fas fa-link",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Lien: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "libelle",
            dataField: "libelle",
            caption: "Libellé lien",
            icon: "fas fa-link",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Libellé lien: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }, {
            name: "adresse_email",
            dataField: "adresse_email",
            caption: "Destinataire",
            icon: "fas fa-user",
            allowFilter: false,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: false,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-home dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Destinataire: " +
                    options.displayValue +
                    " (" + tot + ")")
            }
        }])

        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []
        if (typeof option.showBtNew == 'undefined' || option.showBtNew) {
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        dxBtNewEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-comment-sms",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            txtTooltip: "Nouveau SMS",
            //            onClick: function (e) {
            //                option.bddCtrl.getObjet("com_sms_envoi").objetMetier.mShowNewSms()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        dxBtNewDocEmail = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-file",
            //            icon2: "fas fa-certificate",
            //            colorIcone2: theme.colorBtIcon2,
            //            opacityIcone2: "0.9",
            //            icon3: "fas fa-at",
            //            colorIcone3: theme.color,
            //            leftIcone3: true,
            //            txtTooltip: "Nouveau document email",
            //            onClick: function (e) {
            //                (new cObjetFichierEmlzMetier(null, bdd)).mShowNewDocumentEmail()
            //            }
            //        }).dxCtrlButton("instance")
            //    }
            //})
        }

        return items
    }

    //var dxBtAddDossier = null
    //var dxBtAddPipeline = null
    //var dxBtDonwload = null
    function mGetLstButtonToolBarSelect(dxVirtualGrid) {
        var items = []
        var itemToolbar = {
            location: 'before',
            visible: (dxVirtualGrid && dxVirtualGrid.toolbarSelectIsVisible),
            template: function (itemData, itemIndex, itemElement) {
                var dxBtAfficheGrilleStrCon = $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fas fa-bars-staggered",
                    icon2: "fas fa-ellipsis",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    hint: "Afficher la grille structures/contacts des clicks",
                    onClick: function (e) {
                        var xlstIdTableId = ""
                        dxVirtualGrid.mGetLstTraitementData().forEach(function (dataGrid) {
                            xlstIdTableId += ((xlstIdTableId.length > 0) ? "," : "") + dataGrid.id
                        })
                        if (xlstIdTableId.length > 0) {
                            option.bddCtrl.mAjaxCall({ command: "getdataslstsmsclick", lstid: xlstIdTableId }, function (data) {
                                data.lstsmsclick = JSON.parse(data.lstsmsclick)
                                //if (typeof data.lstsmsclick == 'undefined') data.lstsmsclick = []
                                if (data.lstsmsclick.length > 0) {
                                    page.mAddPopupLst("Liste des clicks sms" + ((typeof option.objet == 'undefined') ? "" : " &bull; " + option.objet), function (contentElement) {
                                        $("<div style='width:100%;height:100%;'/>").appendTo(contentElement).dxCtrlPopupLstStrConTempo({
                                            bddCtrl: option.bddCtrl,
                                            lstIdTableIdInclu: data.lstsmsclick
                                        })
                                    })
                                } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                            })
                        } else { mNotify("Aucune fiche à afficher", "warning", 6000) }
                    }
                }).dxCtrlButton("instance")
                dxVirtualGrid.lstButtonForCheck.push(dxBtAfficheGrilleStrCon)
            }
        }
        dxVirtualGrid.lstItemToolbarForCheck.push(itemToolbar)
        items.push(itemToolbar)

        if (typeof option.showBtTraitement == 'undefined' || option.showBtTraitement) {


            //if (option.bddCtrl.objCptCli.objetMetier.hasDossier()) {
            //    items.push({
            //        location: 'before',
            //        template: function (itemData, itemIndex, itemElement) {
            //            itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //            var dxBtAddDossier = option.bddCtrl.getObjet("dossier").objetMetier.mGetButtonToolBarAddDansDossier(itemElement, function () { return dxVirtualGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_click inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_click.id_com_sms_envoi_tracking_click=tab.id INNER JOIN com_destinataire ON com_sms_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
            //        }
            //    if((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtAddDossier) window.setTimeout(function () { dxBtAddDossier.element().closest(".dx-toolbar-button").hide() }, 0)
            //    dxVirtualGrid.lstButtonForCheck.push(dxBtAddDossier)
            //})
            //}
            //if (option.bddCtrl.objCptCli.objetMetier.hasPipeline()) {
            //    items.push({
            //        location: 'before',
            //        template: function (itemData, itemIndex, itemElement) {
            //            itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //            var dxBtAddPipeline = option.bddCtrl.getObjet("pipeline").objetMetier.mGetButtonToolBarAddDansPipeline(itemElement, function () { return dxVirtualGrid }, "select distinct com_destinataire.id_table_destinataire as id_table,com_destinataire.id_destinataire as id from com_sms_envoi_tracking_click inner join (select value as id from string_split('%lstid%',',')) as tab ON com_sms_envoi_tracking_click.id_com_sms_envoi_tracking_click=tab.id INNER JOIN com_destinataire ON com_sms_envoi_tracking_click.id_com_destinataire=com_destinataire.id_com_destinataire where not com_destinataire.id_destinataire is null")
            //        }
            //        if((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtAddPipeline) window.setTimeout(function () { dxBtAddPipeline.element().closest(".dx-toolbar-button").hide() }, 0)
            //    dxVirtualGrid.lstButtonForCheck.push(dxBtAddPipeline)
            //})
            //}
            //items.push({
            //    location: 'before',
            //    template: function (itemData, itemIndex, itemElement) {
            //        itemElement.closest(".dx-toolbar-item").css("background-color", theme.backgroundcolorBase)
            //        var dxBtDonwload = $("<div/>").appendTo(itemElement).dxCtrlButton({
            //            icon: "fas fa-cloud-arrow-up",
            //            txtTooltip: "Exporter la liste des contacts qui ont vues",
            //            onClick: function (e) {
            //                var lstDataTraitement = dxVirtualGrid.mGetLstSelectedData()
            //                if (lstDataTraitement.length == 0) lstDataTraitement = dxVirtualGrid.mGetLstData()
            //                if (lstDataTraitement.length == 0) {
            //                    mNotify("Aucune donnée à exporter.", "warning", 6000)
            //                } else {
            //                    jaugeDemarrage.mShow()
            //                    var lstIdTableId = []
            //                    lstDataTraitement.forEach(function (data) {
            //                        lstIdTableId.push({ id: data.id })
            //                    })
            //                    option.bddCtrl.mAjaxCall({
            //                        command: "exportstrconclicksms",
            //                        data: lstDataTraitement
            //                    }, function (data) {
            //                        if (data.urlfile.startsWith("~")) data.urlfile = data.urlfile.substring(1)
            //                        window.open(data.urlfile)
            //                        jaugeDemarrage.mHide()
            //                        mNotify("Votre exportation est fini. Le fichier est en cours de téléchargement.", "success", 6000)
            //                    })
            //                }
            //            }
            //        }).dxCtrlButton("instance")
            //        if ((!dxVirtualGrid || !dxVirtualGrid.toolbarSelectIsVisible) && dxBtDonwload) window.setTimeout(function () { dxBtDonwload.element().closest(".dx-toolbar-button").hide() }, 0)
            //        dxVirtualGrid.lstButtonForCheck.push(dxBtDonwload)
            //    }
            //})
        }
        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {

    }

    this.mChangeLstIdTableIdExclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdExclu(lstId)
    }
    this.mChangeLstIdTableIdInclu = function (lstId) {
        dxGrid.mChangeLstIdTableIdInclu(lstId)
    }

    this.element = function () { return container }

    mConstruit();
}